import {
    refreshStore as initService,
    refreshProfile
} from '@/services/auth'

import * as globalTypes from '@/store/global/mutations_types'
import * as awTypes from '@/modules/parameters/access_ways/store/mutations_types'
import * as authTypes from '@/modules/auth/store/mutations_types'
import * as companyTypes from '@/modules/company/store/mutations_types'
import * as lrTypes from '@/modules/parameters/loss_reasons/store/mutations_types'
import * as packageTypes from '@/modules/parameters/packages/store/mutations_types'
import * as paymentMethodTypes from '@/modules/parameters/payment_methods/store/mutations_types'
import * as pipelineTypes from '@/modules/parameters/pipelines/store/mutations_types'
import * as productsTypes from '@/modules/parameters/products/store/mutations_types'
import * as pcTypes from '@/modules/parameters/product_categories/store/mutations_types'
import * as profileTypes from '@/modules/profile/store/mutations_types'
import * as quotationTypes from '@/modules/deals/components/show/quotations/store/mutations_types'
import * as segmentsTypes from '@/modules/parameters/segments/store/mutations_types'
import * as sourcesTypes from '@/modules/parameters/sources/store/mutations_types'
import * as suppliersTypes from '@/modules/parameters/suppliers/store/mutations_types'
import * as teamsTypes from '@/modules/parameters/teams/store/mutations_types'
import * as templatesTypes from '@/modules/templates/store/mutations_types'

import store from '@/store/index'
import router from '@/router/index'

export const toggleMainMenu = (context) => {
    context.commit(globalTypes.TOGGLE_MAIN_MENU)
}

export const initProfile = (context) => {
    context.commit(authTypes.SET_TOKEN, window.localStorage.getItem('pml_token'))
    return refreshProfile()
        .then(response => {
            context.commit(profileTypes.SET_ROLE, response.data.role)
            context.commit(profileTypes.SET_MEMBER, response.data.member)
            context.commit(profileTypes.SET_NOTIFICATIONS, response.data.notifications)
            context.commit(profileTypes.SET_PREFERENCES, response.data.member_preferences)
            context.commit(profileTypes.SET_INTEGRATIONS, response.data.integrations)
        })
}

export const initStore = (context) => {
    return initService()
        .then(response => {
            context.commit(globalTypes.INIT_STATE)
            context.commit(companyTypes.SET_COMPANY, response.data.company)
            context.commit(companyTypes.SET_MEMBERS, response.data.members)
            context.commit(companyTypes.SET_CURRENCIES, response.data.currencies)
            context.commit(companyTypes.SET_TENANT, response.data.tenant)

            context.commit(awTypes.SET, response.data.access_ways)
            context.commit(lrTypes.SET, response.data.loss_reasons)
            context.commit(packageTypes.SET, response.data.packages)
            context.commit(paymentMethodTypes.SET, response.data.payment_methods)
            context.commit(pipelineTypes.SET, response.data.pipelines)
            context.commit(productsTypes.SET, response.data.products)
            context.commit(pcTypes.SET, response.data.product_categories)
            context.commit(segmentsTypes.SET, response.data.segments)
            context.commit(sourcesTypes.SET, response.data.sources)
            context.commit(suppliersTypes.SET, response.data.suppliers)
            context.commit(teamsTypes.SET, response.data.teams)
            context.commit(templatesTypes.SET_TEMPLATES, response.data.templates)
        })
        .then(() => {
            if (store.getters.isInactiveAccount)
                router.push({ name: 'subscription.index' })
        })
}

export const clearStore = (context) => {
    window.localStorage.removeItem('pml_reports_follow_ups_show_all')
    window.localStorage.removeItem('pml_reports_follow_ups_created_at_from')
    window.localStorage.removeItem('pml_reports_follow_ups_created_at_to')
    window.localStorage.removeItem('pml_reports_follow_ups_show_log')
    window.localStorage.removeItem('pml_reports_follow_ups_member_id')
    window.localStorage.removeItem('pml_reports_follow_ups_access_way_id')
    window.localStorage.removeItem('pml_reports_follow_ups_segment_id')
    window.localStorage.removeItem('pml_reports_tasks_access_way_id')
    window.localStorage.removeItem('pml_reports_tasks_due_date_at_from')
    window.localStorage.removeItem('pml_reports_tasks_due_date_at_to')
    window.localStorage.removeItem('pml_reports_tasks_status_s')
    window.localStorage.removeItem('pml_last_pipeline_kanban')
    window.localStorage.removeItem('pml_last_member_id_kanban')
    window.localStorage.removeItem('pml_last_deal_status_kanban')
    window.localStorage.removeItem('pml_last_sources_kanban')
    window.localStorage.removeItem('pml_last_segments_kanban')
    window.localStorage.removeItem('pml_last_perceptions_kanban')
    window.localStorage.removeItem('pml_emails_status_s')

    context.commit(companyTypes.CLEAR_STATE)
    context.commit(authTypes.CLEAR_STATE)
    context.commit(profileTypes.CLEAR_STATE)

    context.commit(awTypes.CLEAR)
    context.commit(lrTypes.CLEAR)
    context.commit(packageTypes.CLEAR)
    context.commit(paymentMethodTypes.CLEAR)
    context.commit(pipelineTypes.CLEAR)
    context.commit(productsTypes.CLEAR)
    context.commit(pcTypes.CLEAR)
    context.commit(quotationTypes.CLEAR)
    context.commit(segmentsTypes.CLEAR)
    context.commit(sourcesTypes.CLEAR)
    context.commit(suppliersTypes.CLEAR)
    context.commit(teamsTypes.CLEAR)

    context.commit(templatesTypes.CLEAR_TEMPLATE)
    context.commit(globalTypes.CLEAR_STATE)
}



// WEBPACK FOOTER //
// ./src/store/global/actions.js